import {
  CancelIcon,
  CheckCircleIcon,
  InfoIcon,
  ListPlusIcon,
  RefreshIcon,
  ReplayIcon,
  type IconComponent,
} from '@billda/design-system';
import type { PlotEventType } from '../../../types/plotTimeline';

interface IconConfig {
  Icon: IconComponent;
  className: string;
}

const cancelError: IconConfig = {
  Icon: CancelIcon,
  className: 'text-content-error',
};

const iconConfig: Record<PlotEventType, IconConfig> = {
  AllocationBooked: {
    Icon: ListPlusIcon,
    className: 'text-content-accent',
  },
  AllocationApproved: {
    Icon: CheckCircleIcon,
    className: 'text-content-success',
  },
  AllocationRejected: cancelError,
  AllocationCancelled: {
    Icon: CancelIcon,
    className: 'text-content-warning',
  },
  AllocationAdminCancelled: cancelError,
  AllocationRebooked: {
    Icon: ReplayIcon,
    className: 'text-content-info',
  },
  AllocationResubmitted: {
    Icon: RefreshIcon,
    className: 'text-content-info',
  },
};

const defaultIcon: IconConfig = {
  Icon: InfoIcon,
  className: 'text-content-secondary',
};

export interface EventIconProps {
  eventType: PlotEventType;
  size?: 'small' | 'medium';
}

export function EventIcon({ eventType, size = 'medium' }: EventIconProps) {
  const iconSize = size === 'small' ? 'size-5' : 'size-6';
  const { Icon, className } = iconConfig[eventType] ?? defaultIcon;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Icon className={iconSize} aria-hidden="true" />
    </div>
  );
}
